import {useQuery} from '@tanstack/react-query';
import {queryClient} from '@/utils/reactQueryClient';
import {Message} from '@/api/messages/types';
import {
  conversationMessagesQueryKey,
  fetchConversationMessages,
  mergePendingMessages,
} from '@/api/messages';
import {MESSAGES_POLL_INTERVAL_MS} from '@/api/messages/constants';

export default function useConversationMessagesQuery(
  conversationId: string | null,
  {
    enabled = true,
    pollIntervalMs = MESSAGES_POLL_INTERVAL_MS,
  }: {enabled?: boolean; pollIntervalMs?: number} = {}
) {
  const isEnabled = enabled && Boolean(conversationId);
  const queryKey = conversationMessagesQueryKey(conversationId ?? '');
  const {data, isLoading, isError, error, refetch, isFetching} = useQuery({
    queryKey,
    queryFn: async () => {
      const fetched = await fetchConversationMessages(conversationId as string);
      const previous = queryClient.getQueryData<Message[]>(queryKey) ?? [];
      return mergePendingMessages(fetched, previous);
    },
    enabled: isEnabled,
    refetchInterval: isEnabled ? pollIntervalMs : false,
    refetchOnWindowFocus: true,
  });

  return {
    messages: data ?? [],
    isLoading: isEnabled && isLoading,
    isError,
    error,
    refetch,
    isFetching,
  };
}
